import React from 'react';
import {Link} from "react-router-dom";
import {Table} from "reactstrap";
import _ from "lodash";
import numberFormat from "../../../helpers/numberFormat";
import moment from "moment";

export const prepareGroupedTable = (table) => {
  if (!Array.isArray(table)) return []
  return table.map(sup => ({
    ...sup,
    rows: Array.isArray(sup.rows) ? sup.rows : [],
    netto: _.sumBy(sup.rows, 'netto'),
    krs1C: _.sumBy(sup.rows, 'krs1C'),
    nds: _.sumBy(sup.rows, 'nds'),
    krsKayar1C: _.sumBy(sup.rows, 'krsKayar1C'),
    krsSite: _.sumBy(sup.rows, 'krsSite')
  }))
}

const IssuedGroupedTable = ({data, withNds}) => {
  if (!data) return null
  return (
    <div className={'tableFixOnlyHead'}>
      <Table bordered>
        <thead>
        <tr>
          <th>Выписан</th>
          <th>Билет</th>
          <th>Пассажир</th>
          <th>Маршрут</th>
          <th>Нетто</th>
          <th>Крс 1с</th>
          {withNds && <th>НДС</th>}
          <th>КрсКаяр 1с</th>
          <th>Крс Сайт</th>
          <th>Итого</th>
        </tr>
        </thead>
        <tbody>
        <tr style={{backgroundColor: "#d9ead3"}}>
          <td colSpan={4}>Итого</td>
          <td>{numberFormat(_.sumBy(data, 'netto'))}</td>
          <td>{numberFormat(_.sumBy(data, 'krs1C'))}</td>
          {withNds && <td>{numberFormat(_.sumBy(data, 'nds'))}</td>}
          <td>{numberFormat(_.sumBy(data, 'krsKayar1C'))}</td>
          <td>{numberFormat(_.sumBy(data, 'krsSite'))}</td>
          <td>{numberFormat(_.sumBy(data, (s)=>(s.netto+s.krs1C+s.krsKayar1C+s.krsSite+(withNds ? s.nds:0))))}</td>
        </tr>
        {data.map((sup, i) => {
          return <React.Fragment key={i}>
            <tr style={{backgroundColor: "#cfe2f3"}}>
              <td colSpan={4}>{sup.counterparty}</td>
              <td>{numberFormat(sup.netto)}</td>
              <td>{numberFormat(sup.krs1C)}</td>
              {withNds && <td>{numberFormat(sup.nds)}</td>}
              <td>{numberFormat(sup.krsKayar1C)}</td>
              <td>{numberFormat(sup.krsSite)}</td>
              <td>{numberFormat(sup.netto+sup.krs1C+sup.krsKayar1C+sup.krsSite+(withNds ? sup.nds:0))}</td>
            </tr>
            {_.sortBy(sup.rows, (r)=>(moment(r.issueDate,'DD.MM.YYYY').unix())).map((r,i)=>{
              return <tr key={i}>
                <td>{r.issueDate}</td>
                <td>{r.baseURL && r.id
                  ? <Link to={r.baseURL + r.id} target={'_blank'}>{r.ticket}</Link>
                  : r.ticket}</td>
                <td>{r.pax}</td>
                <td>{r.route}</td>
                <td>{numberFormat(r.netto)}</td>
                <td>{numberFormat(r.krs1C)}</td>
                {withNds && <td>{numberFormat(r.nds)}</td>}
                <td>{numberFormat(r.krsKayar1C)}</td>
                <td>{numberFormat(r.krsSite)}</td>
                <td>{numberFormat(r.netto + r.krs1C + r.krsKayar1C + r.krsSite+(withNds ? r.nds:0))}</td>
              </tr>
            })}
          </React.Fragment>
        })}
        </tbody>
      </Table>
    </div>
  );
};

export default IssuedGroupedTable;
